import React from 'react';
import { Hash, X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const HashtagEditor = ({ hashtags, hashtagInput, onInputChange, onAdd, onRemove }) => {
  return (
    <Card className="border-slate-100">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold flex items-center gap-2">
          <Hash className="h-4 w-4" />
          Hashtags
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="flex flex-wrap gap-2 mb-3">
          {hashtags.map((tag) => (
            <Badge
              key={tag}
              variant="secondary"
              className="bg-slate-100 text-slate-700 cursor-pointer hover:bg-red-100 hover:text-red-700"
              onClick={() => onRemove(tag)}
            >
              {tag}
              <X className="h-3 w-3 ml-1" />
            </Badge>
          ))}
        </div>
        <div className="flex gap-2">
          <Input
            placeholder="Add hashtag..."
            value={hashtagInput}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), onAdd())}
            className="flex-1"
            data-testid="hashtag-input"
          />
          <Button variant="outline" onClick={onAdd}>
            Add
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default HashtagEditor;
